export default {
  Title: 'Leads',
  ClientPage: 'See Active Clients',
  ClientStatus: 'Client status: ',
  Relationships: 'Relationships: ',
  Caregivers: 'Caregivers: ',
  Action: 'Create New Client',
  Card: {
    Subtitles: {
      Created: 'Joined',
      Days: 'Days',
      InStage: 'In stage: #{value}',
      SinceLastMsg: 'Last msg: #{value}',
      StartTimeline: 'Start Timeline',
      HrsPerWeek: 'Hrs/Week',
      CareRelationship: 'Care Relationship',
      MatchDifficulty: 'Match Difficulty',
    },
    SubtitleValue: {
      Day: '#{number} day',
      Days: '#{number} days',
      TwoWeeks: 'Two Weeks',
      FourWeeks: 'Four Weeks',
      Other: 'Other',
    },
  },
  Filter: {
    Search: 'Search',
    SearchPlaceholder: 'Name or Contact',
    Status: 'Status',
  },
};
